import {
  ApartmentOutlined,
  BoltOutlined,
  CampaignOutlined,
  DateRangeOutlined,
  MonetizationOnOutlined,
  SettingsOutlined,
} from '@mui/icons-material'
import { useTranslation } from 'react-i18next'

import ListItemLink from '@/components/navigation/ListItemLink'
import { usePermissions } from '@/features/authorization/contexts/PermissionsContext'

type CustomerNavBarItemsProps = {
  isCollapsed?: boolean
}

function CustomerNavBarItems({ isCollapsed = false }: Readonly<CustomerNavBarItemsProps>) {
  const { t } = useTranslation()
  const { permissions } = usePermissions()

  return (
    <>
      {permissions.has('powerMeasurements') && (
        <ListItemLink
          activePath={'/sites/power-measurements'}
          icon={<BoltOutlined />}
          isCollapsed={isCollapsed}
          primary={t('component.navbar.power_measurements')}
          to="/sites/power-measurements"
        />
      )}
      <ListItemLink
        activePath={'/sites/unavailability'}
        icon={<DateRangeOutlined />}
        isCollapsed={isCollapsed}
        primary={t('customer_details.tabs.unavailability.title')}
        to="/sites/unavailability"
      />
      <ListItemLink
        activePath={'/activations/*'}
        icon={<CampaignOutlined />}
        isCollapsed={isCollapsed}
        primary={t('customer_details.tabs.activations')}
        to="/activations"
      />
      {permissions.has('revenues') && (
        <ListItemLink
          activePath={'/sites/revenue'}
          icon={<MonetizationOnOutlined />}
          isCollapsed={isCollapsed}
          primary={t('component.navbar.revenue')}
          to="/sites/revenue"
        />
      )}
      <ListItemLink
        activePath={'/sites/company-info'}
        icon={<ApartmentOutlined />}
        isCollapsed={isCollapsed}
        primary={t('component.navbar.company_info')}
        to="/sites/company-info"
      />
      <ListItemLink
        activePath={'/sites/settings'}
        icon={<SettingsOutlined />}
        isCollapsed={isCollapsed}
        primary={t('customer_details.tabs.settings.title')}
        to="/sites/settings"
      />
    </>
  )
}

export default CustomerNavBarItems
